import React, { useState, useEffect, useRef } from 'react'
import { Box, Snackbar, Alert } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import SideBar from '../components/layout/SideBar'
import Designations from '../components/designation/Designations'
import Footer from '../components/Footer'
import DesignationForm from '../components/designation/DesignationForm'
import {
  fetchDesignations,
  createDesignation,
  updateDesignation,
} from '../slices/designationsApiSlice'

const DesignationScreen = () => {
  const [selectedDesignation, setSelectedDesignation] = useState(null)

  const [isAdding, setIsAdding] = useState(true)
  const dispatch = useDispatch()

  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [snackbarSeverity, setSnackbarSeverity] = useState('success')

  const hasSwitchedToEdit = useRef(false)

  const { list: designations } = useSelector((state) => state.designations)
  const existingCodes = designations
    .filter((designation) => designation.id !== selectedDesignation?.id)
    .map((designation) => designation.code)
    .filter(Boolean)

  const handleSelectedDesignation = (designation) => {
    if (designation) {
      setSelectedDesignation(designation)
      setIsAdding(false)
      hasSwitchedToEdit.current = true
    }
  }

  const handleSaveDesignation = (updatedDesignation) => {
    dispatch(updateDesignation(updatedDesignation))
      .then(() => {
        showSnackbar('Designation updated successfully', 'success')
        setSelectedDesignation(null)
        setIsAdding(true)
      })
      .catch(() => showSnackbar('Failed to update designation', 'error'))
  }

  const handleAddDesignation = (newDesignation) => {
    dispatch(createDesignation(newDesignation))
    setSelectedDesignation(null)
    setIsAdding(true)
  }

  const handleAddNew = () => {
    setSelectedDesignation(null)
    setIsAdding(true)
    hasSwitchedToEdit.current = false
  }

  const handleDeleteDesignation = () => {
    setSelectedDesignation(null)
  }

  useEffect(() => {
    dispatch(fetchDesignations())
  }, [dispatch])

  const handleCancel = () => {
    setSelectedDesignation(null)
    setIsAdding(true)
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false)
  }

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message)
    setSnackbarSeverity(severity)
    setSnackbarOpen(true)
  }

  return (
    <>
      <Box sx={{ display: 'flex', height: '98vh' }}>
        <SideBar />
        <Box
          component='main'
          sx={{
            flexGrow: 1,
            marginBottom: 2,
            marginRight: 2,
            marginTop: 9,
            display: 'flex',
            paddingLeft: 2,
          }}>
          <Box sx={{ flex: 0.4, marginRight: 2, height: '100%' }}>
            <Designations
              selectedDesignation={selectedDesignation}
              onSelectDesignation={handleSelectedDesignation}
              onDeleteDesignation={handleDeleteDesignation}
              onAddNew={handleAddNew}
              setIsAdding={setIsAdding}
              setSelectedDesignation={setSelectedDesignation}
            />
          </Box>
          <Box sx={{ flex: 0.6, height: '100%' }}>
            <DesignationForm
              designation={selectedDesignation}
              onSave={isAdding ? handleAddDesignation : handleSaveDesignation}
              isAdding={isAdding}
              existingCodes={existingCodes}
              onCancel={handleCancel}
              showSnackbar={showSnackbar}
              setIsAdding={setIsAdding}
            />
          </Box>
        </Box>
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Box component='footer' sx={{ height: '10px' }}>
        <Footer />
      </Box>
    </>
  )
}

export default DesignationScreen
